import { strStartsWith } from '../../../../../services/strings';
import { clearBillingAccountId, getBillingAccountId, inIframe, setBillingAccountId } from '../../../services/app-storage';
import { getSessionItem } from '../../../services/browser-storage';
import onMessage from '../../../services/external-messages';
import { getUrlParam } from '../../../services/url-params';

const ACCOUNTS_PREFIX = 'billing-accounts:';
const READY_MESSAGE = 'booking-tool:ready';

interface IBillingAccount {
    id: number;
    name: string;
}

export function loadBillingAccount(): void {
    if (!inIframe) return;
    if (getUrlParam('whitelabel') || getSessionItem('whitelabel')) return;

    if (!document.getElementById('mainForm')) return;

    const row = document.getElementById('billingAccountRow');
    const select = document.getElementById('billingAccountSwitcher') as HTMLSelectElement | null;
    if (!row || !select) return;

    clearBillingAccountId();

    select.addEventListener('change', () => {
        const parsed = parseInt(select.value, 10);
        if (Number.isFinite(parsed) && parsed > 0) {
            setBillingAccountId(parsed);
            select.classList.remove('error');
        } else {
            clearBillingAccountId();
        }
    });

    let received = false;

    onMessage(msg => {
        let accounts: IBillingAccount[];
        try {
            accounts = JSON.parse(msg.substring(ACCOUNTS_PREFIX.length));
        } catch (e) {
            return;
        }
        if (!Array.isArray(accounts)) return;

        received = true;

        const placeholder = select.firstElementChild;
        select.innerHTML = '';
        if (placeholder) select.appendChild(placeholder);
        accounts.forEach(account => {
            const option = document.createElement('option');
            option.value = String(account.id);
            option.textContent = account.name;
            select.appendChild(option);
        });

        if (accounts.length === 1) {
            setBillingAccountId(accounts[0].id);
            select.value = String(accounts[0].id);
            row.setAttribute('hidden', '');
            return;
        }

        const current = getBillingAccountId();
        if (current !== null && accounts.some(a => a.id === current)) {
            select.value = String(current);
        } else {
            select.selectedIndex = 0;
        }

        if (accounts.length > 1) {
            row.removeAttribute('hidden');
        } else {
            row.setAttribute('hidden', '');
        }
    }, msg => strStartsWith(msg, ACCOUNTS_PREFIX));

    let attempts = 0;
    const announce = () => {
        if (received || attempts >= 5) return;
        parent.postMessage(READY_MESSAGE, '*');
        attempts++;
        setTimeout(announce, 200);
    };
    announce();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/bundle/billing-account/billing-account-loader.ts